import axios from '@/libs/api.request'
// 协议上传
export const subPreProjectAgreementUpload = data => {
  return axios.request({
    url: '/pre/project/agreement/upload',
    data,
    method: 'POST'
  })
}
